import './bookings.css'
import {
    Container,
    Tabs,
    Tab,
} from "react-bootstrap";

import React from "react";
import RequestedBookings from './requested-bookings';
import ConfirmedBookings from './confirmed-bookings';
import NoShow from './no-show';
import ReactGA from 'react-ga';

export default function Bookings (props) {
    ReactGA.pageview(window.location.pathname + window.location.search);    
    const clinic_id = props.location.state.clinicData._id;

        return (
            <Container className="my-2">

              <Tabs defaultActiveKey='requested' id="uncontrolled-tab-example">
                <Tab eventKey="requested" title="Requested">
                  <RequestedBookings clinic_id={clinic_id}/>
                </Tab>
                <Tab eventKey="confirmed" title="Confirmed">
                  <ConfirmedBookings clinic_id={clinic_id}/>
                </Tab>
                <Tab eventKey="no_show" title="No Show">
                  <NoShow clinic_id={clinic_id}/>
                </Tab>
                </Tabs>

          </Container>
        );
      }
    